module.exports = __webpack_public_path__ + "img/img12.c6817668.png";